export default __webpack_public_path__ + "static/media/KOD0122-min.ec0663cc.webp";